var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      staticClass: "vab-card",
      attrs: { "body-style": _vm.bodyStyle, shadow: _vm.shadow },
      scopedSlots: _vm._u(
        [
          _vm.$slots.header || _vm.header
            ? {
                key: "header",
                fn: function () {
                  return [
                    _vm._t("header", function () {
                      return [_vm._v(_vm._s(_vm.header))]
                    }),
                    _c("el-button", {
                      staticStyle: {
                        float: "right",
                        position: "relative",
                        bottom: "5px",
                      },
                      attrs: {
                        type: "text",
                        size: "medium",
                        icon: "el-icon-arrow-down",
                      },
                    }),
                  ]
                },
                proxy: true,
              }
            : null,
        ],
        null,
        true
      ),
    },
    [
      _vm.localSkeleton
        ? _c("el-skeleton", {
            attrs: {
              animated: "",
              loading: _vm.skeletonShow,
              rows: _vm.skeletonRows,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function () {
                    return [_vm._t("default")]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          })
        : _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }